import script from "./WriterCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./WriterCenter.vue?vue&type=script&setup=true&lang=js"

import "./WriterCenter.vue?vue&type=style&index=0&id=14718338&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14718338"]])

export default __exports__